// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2300":"f84f219793ec4949","8122":"6bf4dbce460b2ed2"}[chunkId] + ".js";
};